import { Controller } from "@hotwired/stimulus"
import { enter, leave, toggle } from 'el-transition'

export default class extends Controller {

  static targets = ["container", "overlay", "modal", "content", "loading", "errorMessages", "checkedField"]
  static values = { 
    open: { type: Boolean, default: false }, 
    local: { type: Boolean, default: false } 
  }

  connect() {
    if (this.openValue == true) {
      this._open()
    }
  }

  open(event) {
    if (event.params.maxWidth) {
      this.modalTarget.classList.remove("md:w-1/2", "md:max-w-lg")
      this.modalTarget.classList.add(event.params.maxWidth)
      this.modalTarget.setAttribute('data-modal-max-width', event.params.maxWidth)
    }
    this.openValue = true
  }

  close(event) {
    if (this._hasChildModal()) return  // Prevent closing if a nested modal is open

    this.openValue = false
  }

  openValueChanged() {
    if (this.openValue) {
      this._open()
    } else {
      this._close()
    }
  }

  _open() {
    // this._updateZIndex()
    enter(this.containerTarget)
    enter(this.overlayTarget)
    enter(this.modalTarget)
  }

  _close() {
    if (this._hasChildModal()) return  // Prevent closing if a nested modal is open

    leave(this.modalTarget)
    leave(this.overlayTarget)
    leave(this.containerTarget)
    // this.element.style.zIndex = ""
    
    let maxWidth = this.modalTarget.dataset.modalMaxWidth
    // Wait until modal is closed
    setTimeout(() => {
      if (maxWidth) {
        this.modalTarget.classList.remove(maxWidth)
        this.modalTarget.classList.add("md:w-1/2")
        this.modalTarget.removeAttribute('data-modal-max-width')
      }
    }, 200)
  }

  // Checks if a child modal is open
  _hasChildModal() {
    return this.modalTarget.querySelector("[data-controller='modal'][data-modal-open-value='true']") !== null
  }

  // Update z-index to ensure nesting works
  _updateZIndex() {
    const modals = document.querySelectorAll("[data-controller='modal'][data-modal-open-value='true']")
    let baseZIndex = 50
    modals.forEach((modal, index) => {
      modal.style.zIndex = baseZIndex + index * 10
    })
  }

  // Prevent background click from closing all modals
  overlayClick(event) {
    if (event.target === this.overlayTarget && !this._hasChildModal()) {
      this.close()
    }
  }

  displayLoading(event) {
    this.loadingTarget.classList.remove('hidden')
    this.contentTarget.classList.add('hidden')
  }

  displayContent() {
    this.loadingTarget.classList.add('hidden')
    this.contentTarget.classList.remove('hidden')
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.close()
    }
  }

  closeIfValidated(event) {
    console.log("Validating form before closing modal...")
    const errors = []
    this.checkedFieldTargets.forEach(field => {
      field.setCustomValidity("") // Reset validation

      if (field.type === "hidden" || field.readOnly) {
        if (!field.value.trim()) {
          const customMessage = field.dataset.validationMessage || "This field is required."
          errors.push(customMessage)
        }
      } else {
        if (!field.checkValidity()) {
          const customMessage = field.dataset.validationMessage || field.validationMessage || "Invalid input"
          errors.push(customMessage)
          field.setCustomValidity(customMessage)
          field.reportValidity()
        }
      }
    })

    if (errors.length === 0) {
      this.close()
    } else {
      this._displayErrors(errors)
    }
  }

  _displayErrors(errors) {
    if (this.hasErrorMessagesTarget) {
      this.errorMessagesTarget.innerHTML = errors.map(error => `<p class='text-red-500'>${error}</p>`).join('')
      this.errorMessagesTarget.classList.remove("hidden")
    }
  }
  
  // Scroll the modal content to the top
  scrollToTop() {
    const modalInner = this.modalTarget.querySelector('.modal-inner')
    if (modalInner) {
      modalInner.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}